module.exports = __webpack_public_path__ + "static/img/about-office.78701c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgstore/about-office.png
// module id = 314
// module chunks = 1